// import { camelize, capitalize } from 'vue'
import Page from './Page.vue'
import MultiImg from './MultiImg'
import FTabs from './FTabs'
import ComplianceTips from './ComplianceTips'
import Loading from './Loading.vue'
import CheckButton from './CheckButton.vue'
import SvgIcon from './SvgIcon.vue'
import BottomFixed from './BottomFixed.vue'
import DraggablePopup from './DraggablePopup.vue'

//批量注册自定义通用公共组件
export default function (Vue) {
    const components = [Page, MultiImg, FTabs, ComplianceTips, Loading, CheckButton, SvgIcon, BottomFixed, DraggablePopup]
    components.forEach(item => {
        Vue.component(item.name, item)
    })
}
